import classNames from 'classnames'
import Pill from 'components/home/Pill'
import Paragraphs from 'components/home/common/typography/Paragraphs'
import SectionHeaders from 'components/home/common/typography/SectionHeaders'
import { CheckCircleIcon } from 'components/icons'

export interface BookingConditionsMobileItemProps {
  header: string
  description: string | (string | undefined | null)[]
  showCheckbox?: boolean
  pill?: string
}

const BookingConditionsMobileItem = ({
  header,
  description,
  showCheckbox,
  pill,
}: BookingConditionsMobileItemProps) => {
  return (
    <div className="text-left">
      {
        pill && (
          <div className="float-right pb-5 pl-5">
            <Pill variant="blue" size="10">{pill}</Pill>
          </div>
        )
      }

      <SectionHeaders.MD className="text-grey-900 !font-normal leading-20">
        {header}
      </SectionHeaders.MD>

      {
        Array.isArray(description)
          ? description.map((item, index) => (
            <Paragraphs.SM
              key={index}
              className={classNames(
                'mt-5 whitespace-pre-line leading-20 text-grey-650',
                {
                  'flex items-center gap-x-8': showCheckbox,
                },
              )}
            >
              {showCheckbox && <CheckCircleIcon className="text-primary-fresh text-16" />}{item}
            </Paragraphs.SM>
          ))
          : (
            <Paragraphs.SM className="mt-5 whitespace-pre-line leading-20 text-grey-650">
              {description}
            </Paragraphs.SM>
          )
      }
    </div>
  )
}
export default BookingConditionsMobileItem
